{
  "form": {
    "editTitle": "Edit: {{name}}",
    "createTitle": "Create New Criteria Set",
    "nameLabel": "Criteria Name",
    "nameHelper": "Give this criteria set a descriptive name",
    "nameRequired": "Name is required",
    "priceRange": "Price Range (CHF)",
    "minPrice": "Minimum Price",
    "maxPrice": "Maximum Price",
    "priceMaxError": "Maximum price must be greater than or equal to minimum price",
    "sizeRange": "Property Size (m²)",
    "minSize": "Minimum Size",
    "maxSize": "Maximum Size",
    "sizeMaxError": "Maximum size must be greater than or equal to minimum size",
    "roomsRange": "Number of Rooms",
    "minRooms": "Minimum Rooms",
    "maxRooms": "Maximum Rooms",
    "roomsMaxError": "Maximum rooms must be greater than or equal to minimum rooms",
    "priceNonNegative": "Price must be non-negative",
    "sizeNonNegative": "Size must be non-negative",
    "roomsPositive": "Rooms must be positive",
    "locationTitle": "Location",
    "locationField": "Location (comma-separated)",
    "locationHelper": "e.g., Lausanne, Geneva, Vaud",
    "saving": "Saving...",
    "update": "Update Criteria",
    "create": "Create Criteria"
  },
  "list": {
    "emptyMessage": "No criteria sets configured yet. Create one to start tracking properties.",
    "createButton": "Create Criteria Set",
    "newButton": "New Criteria Set",
    "count_one": "{{count}} Criteria Set",
    "count_other": "{{count}} Criteria Sets",
    "active": "Active",
    "inactive": "Inactive",
    "noFilters": "No filters configured",
    "any": "Any",
    "rooms": "rooms",
    "updated": "Updated: {{date}}",
    "deleteTitle": "Delete Criteria Set",
    "deleteConfirm": "Are you sure you want to deactivate \"{{name}}\"? This criteria set will no longer be used for matching ads."
  },
  "display": {
    "title": "Current Search Criteria",
    "emptyMessage": "No search criteria configured yet. Use the form below to set your preferences.",
    "price": "Price (CHF)",
    "size": "Size (m²)",
    "rooms": "Rooms",
    "location": "Location",
    "any": "Any",
    "lastUpdated": "Last updated: {{date}}"
  },
  "page": {
    "title": "Search Criteria Configuration",
    "description": "Manage filter criteria sets for property searches. Each set defines a combination of price, size, rooms, and location filters.",
    "updated": "Criteria updated successfully!",
    "created": "Criteria created successfully!",
    "deactivated": "Criteria set deactivated."
  }
}
